// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","backdrop":"styles_backdrop__X8D0l","bottom":"styles_bottom__fqbi1","right":"styles_right__51Qsn","children":"styles_children__cfAnS"};